import { CompoApp } from "./CompoApp";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlBuilder } from "../models/frontend_entities/UrlBuilder";
import Constants from "../Constants";
import { UserPrivilegeSetDtoModel } from "../models/rights/user-privilege-set/user-privilege-set-dto.model";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import {
  UserRightsFunctionToUserPrivilegeSetDtoModel
} from "../models/rights/user-rights-function/user-rights-function-to-user-privilege-set-dto.model";

@Injectable()
export class UserPrivilegeSetApiService {

  //region constructor
  constructor(public app: CompoApp, public http: HttpClient) {
  }

  //endregion

  //region GET

  getById(privilegeSetId: string) {
    const url = new UrlBuilder(Constants.URLS.userPrivilegeSet.getById)
      .param("id", privilegeSetId)
      .param("lang", this.app.data.getLang())
      .build();

    return this.http.get<UserPrivilegeSetDtoModel>(url).toPromise();
  }

  getPrivileges(privilegeSetId: string): Observable<any[]> {
    const url = new UrlBuilder(Constants.URLS.userPrivilegeSet.getPrivileges)
      .param("id", privilegeSetId)
      .param("lang", this.app.data.getLang())
      .build();

    return this.http.get<any[]>(url).pipe(take(1));
  }

  //endregion

  //region USER ROLE

  addUserPrivilegeSetsToUserRightsFunctionRx(userPrivilegeSets: UserRightsFunctionToUserPrivilegeSetDtoModel): Observable<boolean> {
    const url = new UrlBuilder(Constants.URLS.userPrivilegeSet.addUserPrivilegeSetsToUserRightsFunction)
      .build();

    return this.http.post<boolean>(url, userPrivilegeSets).pipe(take(1));
  }

  removeUserPrivilegeSetsFromUserRightsFunctionRx(userPrivilegeSets: UserRightsFunctionToUserPrivilegeSetDtoModel): Observable<boolean> {
    const url = new UrlBuilder(Constants.URLS.userPrivilegeSet.removeUserPrivilegeSetsFromUserRightsFunction)
      .build();

    return this.http.post<boolean>(url, userPrivilegeSets).pipe(take(1));
  }

  //endregion

}
